import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  CreditorWatchReadableReport,
  CreditorWatchRelatedEntity,
  CreditorWatchRelatedIndividual,
  CreditorWatchReportAdverseItem,
  CreditorWatchReportDialogData,
  CreditorWatchReportDialogResult,
  toCreditorWatchReadableReport,
} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    templateUrl: './creditorwatch-report.dialog.html',
    styleUrls: ['./creditorwatch-report.dialog.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatTooltipModule, FlexModule]
})
export class CreditorWatchReportDialog {

  report: CreditorWatchReadableReport;

  private individualsShowingClearEntities = new Set<CreditorWatchRelatedIndividual>();
  private entitiesShowingItems = new Set<CreditorWatchRelatedEntity>();
  private itemsShowingFields = new Set<CreditorWatchReportAdverseItem>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CreditorWatchReportDialogData,
    private matDialogRef: MatDialogRef<CreditorWatchReportDialog, CreditorWatchReportDialogResult>
  ) {
    this.report = toCreditorWatchReadableReport(this.data.webService.json);
  }

  personSummary(individual: CreditorWatchRelatedIndividual): string {
    const parts: string[] = [];
    if (individual.dateOfBirth) {
      parts.push(`DOB ${individual.dateOfBirth}`);
    }
    if (individual.roles.length) {
      parts.push(individual.roles.join(', '));
    }
    if (individual.shareholding) {
      parts.push(`Shareholder ${individual.shareholding}`);
    }
    return parts.join(' \u00b7 ');
  }

  isShowingClearEntities(individual: CreditorWatchRelatedIndividual): boolean {
    return this.individualsShowingClearEntities.has(individual);
  }

  toggleClearEntities(individual: CreditorWatchRelatedIndividual) {
    if (this.individualsShowingClearEntities.has(individual)) {
      this.individualsShowingClearEntities.delete(individual);
    } else {
      this.individualsShowingClearEntities.add(individual);
    }
  }

  isShowingItems(entity: CreditorWatchRelatedEntity): boolean {
    return this.entitiesShowingItems.has(entity);
  }

  toggleEntity(entity: CreditorWatchRelatedEntity) {
    if (!entity.adverseGroups.length) {
      return;
    }
    if (this.entitiesShowingItems.has(entity)) {
      this.entitiesShowingItems.delete(entity);
    } else {
      this.entitiesShowingItems.add(entity);
    }
  }

  isShowingFields(item: CreditorWatchReportAdverseItem): boolean {
    return this.itemsShowingFields.has(item);
  }

  toggleFields(item: CreditorWatchReportAdverseItem) {
    if (this.itemsShowingFields.has(item)) {
      this.itemsShowingFields.delete(item);
    } else {
      this.itemsShowingFields.add(item);
    }
  }

  onCancel() {
    this.matDialogRef.close();
  }
}
